<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item active"><a href="">BASIC </a></li>
            <li class="tab-menu__item"><a href="">Advanced Upgrade</a></li>
            <li class="tab-menu__item"><a href="">Advanced Upgrade Premium</a></li>
            <li class="tab-menu__item"><a href="">Advanced Upgrade Diamond</a></li>
            <li class="tab-menu__item"><a href="">ADDITIONAL EXAM ITEMS</a></li>
        </ul>
    </div>
    <div class="tab-menu-con arabic">
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <div class="table">
                        <table>
                            <caption>BASIC</caption>
                            <colgroup>
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                                <col style="width: auto">
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="4">Test</th>
                                    <th scope="col" colspan="2">Costs</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th sope="rowgroup" rowspan="12" style="border-right: 1px solid #b9b9b9;">برنامج
                                        أساسي</th>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>الفحص الطبي الأساسي</span>
                                    </th>
                                    <td class="left">اسات الجسم(طول، وزن)، اختبار لقياس السمنة، ضعط الدم</td>
                                    <td rowspan="11">
                                        الذكر<br>
                                        1,050,000
                                        <br>
                                        KRW
                                    </td>
                                    <td rowspan="11">
                                        الأنيى<br>
                                        1,300,000<br>
                                        KRW
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>فحص السمع</span>
                                    </th>
                                    <td class="left">قياس سمع النغمة النقية</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>فحص العين</span>
                                    </th>
                                    <td class="left">فحص النظر، فحص الضغط في العين، تنظير قاع العين</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>فحص وظائف القلب والرئة</span>
                                    </th>
                                    <td class="left">تصوير الصدر بالأشعة السينية، تخطيط كهربية القلب</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>تحليل البول، البراز</span>
                                    </th>
                                    <td class="left">الفحص المجهري لرواسب البول ، احتبار الدم الخفي في البراز</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>تحليل الدمn</span>
                                    </th>
                                    <td class="left">
                                        تحليل الدم الشامل (RBC, WBC, Hb, Hct, RDW, Platelet, MCV, MCH)<br>
                                        أنواع فواصل الدم (ABO, RH)<br>
                                        فحص فيتامين د<br>
                                        السكري (Glucose, HbA1C)<br>
                                        اختبار وظائف الرئة (T.Protein, Albumin, AST, ALT, ALP, r-GTP, TB, DB)<br>
                                        فحص التهاب الكبد (A/B/C )<br>
                                        مخاطر الشريان التاجي (Homocystein, CRP, CK, Apoprotein A1, Apoprotein B)<br>
                                        فحص فرط شحميات الدم (T.chole, HDL, LDL, TG, LDH)<br>
                                        فحص وظائف الغدة الدرقية (T3, Free T4, TSH)<br>
                                        فحص وظائف الكلى (BUN, Creatinine), تحليل الشوارد (Ca, K, Na, CI.P, T C02)<br>
                                        فحص النقرس (حمض اليوريك)<br>
                                        فحص مصل دم المناعة (RF, VDRL, HIV)<br>
                                        (Amylase, lipase) فحص البنكرياس<br>
                                        علامات الأورام [AFP, CEA, CA19-9, CA 125 (لللأنثى), PSA&amp;free PSA (للذكر)
                                        ,SCC<br>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>فحص سرطان المعدة</span>
                                    </th>
                                    <td class="left">تنظير المعدة (EGD)</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>الموجات فوق الصوتية</span>
                                    </th>
                                    <td class="left">تصوير البطن بالموجات فوق الصوتية</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>الفحص الانتقائي (اختر 1)</span>
                                    </th>
                                    <td class="left">تصوير الغدة الدرقية بالموجات فوق الصوتية(السونار) أو التصوير
                                        المقطعي المحوسب(سي تي سكان) بجرعة منخفضة على الصدر</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>الفحوصات المتوفرة للنساء</span>
                                    </th>
                                    <td class="left">الدراسة الخلوية السائلة (thin prep) ، التصوير السوناري في طب
                                        للنساء ، اختبار HPV ، التصوير الشعاعي للثدي</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>الفحوصات الأخرى</span>
                                    </th>
                                    <td class="left">استشارة الحركة، كثافة العظام</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p class="font-sub mt20">
                        * لنسبة للنساء دون سن الثلاثين ، نوصي بإجراء فحص يتضمن التصوير الشعاعي للثدي إذا كان لديك تاريخ
                        عائلي للإصابة بسرطان الثدي.
                        <br>
                        * إذا كان عمرك أقل من 30 عامًا، يمكنك استبدال تصوير الثدي بالأشعة السينية بفحص الأجسام المضادة
                        للحصبة الألماني
                    </p>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <div class="table">
                        <table>
                            <caption>Advanced Upgrade</caption>
                            <colgroup>
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                                <col style="width: auto">
                                <col style="width: 10%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="3">Test</th>
                                    <th scope="col">Costs</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th rowspan="2" scope="row" class="bl">برنامج الترقية
                                        <br>(برنامج ابجريد)
                                    </th>
                                    <td>الذكر</td>
                                    <td class="left">برنامج أساسي(سي تي سكان بجرعة منخفضة على الصدر + تصوير الغدة
                                        الدرقية بالسونار) + سي تي سكان للبطن والحوض، تنظير القولون تحت التخدير الموضعي
                                    </td>
                                    <td>1,800,000 KRW</td>
                                </tr>
                                <tr>
                                    <td>الأنثى</td>
                                    <td class="left">برنامج أساسي(سي تي سكان بجرعة منخفضة على الصدر + تصوير الغدة
                                        الدرقية بالسونار) + تصوير الثدي بالسونار، سي تي سكان للبطن والحوض، تنظير القولون
                                        تحت التخدير الموضعي</td>
                                    <td>2,280.000 KRW</td>
                                </tr>
                                <tr>
                                    <th rowspan="2" scope="row" class="bl">برنامج ابجريد بلس</th>
                                    <td>الذكر</td>
                                    <td class="left">برنامج ابجريد + تصوير الشريان السباتي بالسونار،سي تي سكان
                                        للقلب(تصوير ثلاثي الأبعاد الشريان التاجي)، تصوير بالرنين المغناطيسي (إم آر
                                        آي)&amp; تصوير الأوعية بالرنين المغناطيسي للمخ</td>
                                    <td>3,800,000 KRW</td>
                                </tr>
                                <tr>
                                    <td>الأنثى</td>
                                    <td class="left">برنامج ابجريد + تصوير الشريان السباتي بالسونار،سي تي سكان
                                        للقلب(تصوير ثلاثي الأبعاد الشريان التاجي)، تصوير بالرنين المغناطيسي (إم آر
                                        آي)&amp; تصوير الأوعية بالرنين المغناطيسي للمخ</td>
                                    <td>4,250,000 KRW</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content ">
            <div class="lang">
                <div class="info">
                    <div class="table table-border02 table-bg01">
                        <table>
                            <caption>Advanced Upgrade Premium</caption>
                            <colgroup>
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                                <col style="width: auto">
                                <col style="width: 10%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="3">Test</th>
                                    <th scope="col">Costs</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="rowgroup" rowspan="2" class="br">برنامج بريميوم</th>
                                    <td>الذكر</td>
                                    <td class="left">
                                        برنامج ابجريد بلس + التصوير المقطعي بالإصدار البوزيتروني (بيت سي تي) للمخ والجسم
                                        الكامل، تخطيط صدى القلب، فحص الهرومون للرجل، ليلة واحدة في غرفة في اي بي
                                    </td>
                                    <td>6,200,000 KRW</td>
                                </tr>
                                <tr>
                                    <td>الأنثى</td>
                                    <td class="left">
                                        برنامج ابجريد بلس + التصوير المقطعي بالإصدار البوزيتروني (بيت سي تي) للمخ والجسم
                                        الكامل، تخطيط صدى القلب، فحص الهرومون للمرأة، ليلة واحدة في غرفة في اي بي
                                    </td>
                                    <td>6,700,000 KRW</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <div class="table">
                        <table>
                            <caption>Advanced Upgrade Diamond</caption>
                            <colgroup>
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                                <col style="width: auto">
                                <col style="width: 10%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="3">Test</th>
                                    <th scope="col">Costs</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="rowgroup" rowspan="2" class="br">برنامج ب داياموند</th>
                                    <td>الذكر</td>
                                    <td class="left">برنامج بريميوم + تصوير الرنين المغناطيسي (إم آر آي) للرقبة+ إم آر
                                        آي للظهر + ليلة واحدة في غرفة في اي بي
                                    </td>
                                    <td>7,750,000 KRW</td>
                                </tr>
                                <tr>
                                    <td>الأنثى</td>
                                    <td class="left">برنامج بريميوم + تصوير الرنين المغناطيسي (إم آر آي) للرقبة+ إم آر
                                        آي للظهر + ليلة واحدة في غرفة في اي بي
                                    </td>
                                    <td>8,200,000 KRW</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content active">
            <div class="lang">
                <div class="info">
                    <div class="table">
                        <table>
                            <caption>ADDITIONAL EXAM ITEMS</caption>
                            <colgroup>
                                <col style="width: 10%;">
                                <col style="width: 20%;">
                                <col style="width: auto">
                                <col style="width: 30%;">
                                <col style="width: 10%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="4">Exam Items</th>
                                    <th scope="col">Costs</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="rowgroup" rowspan="6" class="bl">فحص الجهاز الهضمي</th>
                                    <td rowspan="4" class="bl">الفحص بالمنظار</td>
                                    <td class="left"> التنظير الهضمي العلوي تحت التخدير الموضعي</td>
                                    <td rowspan="4">قد تكون مطلوبا لإزالة الأورام وإجراء الخزعة مما يتسبب في تكاليف
                                        إضافية</td>
                                    <td>120,000</td>
                                </tr>
                                <tr>
                                    <td class="left">تنظير القولون تحت التخدير الموضعي</td>
                                    <td>120,000</td>
                                </tr>
                                <tr>
                                    <td class="left">التنظير الهضمي العلوي والقولون تحت التخدير الموضعي</td>
                                    <td>150,000</td>
                                </tr>
                                <tr>
                                    <td class="left">تنظير القولون</td>
                                    <td>260,000</td>
                                </tr>
                                <tr>
                                    <td>تصوير بالموجات فوق الصوتية(فحص السونار)</td>
                                    <td class="left">تصوير بالموجات فوق الصوتية للبطن</td>
                                    <td></td>
                                    <td>250,000</td>
                                </tr>
                                <tr>
                                    <td>التصوير المقطعي المحوسب(سي تي سكان)</td>
                                    <td class="left">التصوير المقطعي المحوسب للبطن والحوض</td>
                                    <td>باستخدام مادة تباين</td>
                                    <td>370,000</td>
                                </tr>
                                <tr>
                                    <th scope="rowgroup" rowspan="3">فحص المخ</th>
                                    <td rowspan="5" class="bl">التصوير بالرنين المغناطيسي(إم آر آي)</td>
                                    <td class="left">تصوير بالرنين المغناطيسي للمخ</td>
                                    <td></td>
                                    <td>850,000</td>
                                </tr>
                                <tr>
                                    <td class="left">تصوير الأوعية بالرنين المغناطيسي للمخ</td>
                                    <td></td>
                                    <td>850,000</td>
                                </tr>
                                <tr>
                                    <td class="left">تصوير بالرنين المغناطيسي &amp; تصوير الأوعية بالرنين المغناطيسي
                                        للمخ( MR Angio)</td>
                                    <td></td>
                                    <td>1,500,000</td>
                                </tr>
                                <tr>
                                    <th rowspan="2">فحص أسفل الظهر والرقبة</th>
                                    <td class="left">تصوير الرنين المغناطيسي للرقبة</td>
                                    <td></td>
                                    <td>850,000</td>
                                </tr>
                                <tr>
                                    <td class="left">تصوير الرنين المغناطيسي للظهر</td>
                                    <td></td>
                                    <td>850,000</td>
                                </tr>
                                <tr>
                                    <th scope="rowgroup" rowspan="3" class="bl">فحص القلب</th>
                                    <td rowspan="2" class="bl">فحص السونار</td>
                                    <td class="left">تخطيط صدى القلب</td>
                                    <td></td>
                                    <td>300,000</td>
                                </tr>
                                <tr>
                                    <td class="left">تصوير الشريان السباتي بالموجات فوق الصوتية</td>
                                    <td></td>
                                    <td>220,000</td>
                                </tr>
                                <tr>
                                    <td>سي تي سكان</td>
                                    <td class="left">التصوير المقطعي المحوسب للقلب(تصوير ثلاثي الأبعاد الشريان التاجي)
                                    </td>
                                    <td>باستخدام مادة تباين</td>
                                    <td>400,000</td>
                                </tr>
                                <tr>
                                    <th colspan="3">( PET-CT) التصوير المقطعي بالإصدار البوزيتروني للمخ والجسم الكامل
                                    </th>
                                    <td>باستخدام المواد المشعة</td>
                                    <td>1,700,000</td>
                                </tr>
                                <tr>
                                    <th scope="rowgroup" rowspan="2" class="bl">فحص أسفل الظهر والرقبة</th>
                                    <td rowspan="3" class="bl">سي تي سكان</td>
                                    <td class="left">التصوير المقطعي المحوسب للرقبة</td>
                                    <td></td>
                                    <td>230,000</td>
                                </tr>
                                <tr>
                                    <td class="left">التصوير المقطعي المحوسب للظهر</td>
                                    <td></td>
                                    <td>230,000</td>
                                </tr>
                                <tr>
                                    <th>فحص الصدر</th>
                                    <td class="left">التصوير المقطعي المحوسب بجرعة منخفضة على الصدر</td>
                                    <td></td>
                                    <td>220,000</td>
                                </tr>
                                <tr>
                                    <th colspan="3">الموجات فوق الصوتية للغدة الدرقية</th>
                                    <td></td>
                                    <td>220,000</td>
                                </tr>
                                <tr>
                                    <th scope="rowgroup" rowspan="2" class="bl">فحص للذكر</th>
                                    <td>البروستات</td>
                                    <td class="left">الموجات فوق الصوتية على البروستات</td>
                                    <td></td>
                                    <td>230,000</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="left">فحص هرمون التستوستيرون عند الذكور</td>
                                    <td></td>
                                    <td>180,000</td>
                                </tr>
                                <tr>
                                    <th scope="rowgroup" rowspan="2" class="bl">فحص للأنثى</th>
                                    <td>الثدي</td>
                                    <td class="left">تصوير الثدي بالموجات فوق الصوتية</td>
                                    <td></td>
                                    <td>260,000</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="left">فحص الهرمونات للأنثى</td>
                                    <td></td>
                                    <td>200,000</td>
                                </tr>
                                <tr>
                                    <th>آخر</th>
                                    <td>الفحص الطبي الشامل مع إقامة ليلة واحدة</td>
                                    <td class="left">غرفة في اي بي</td>
                                    <td>لا يوجد خصومات</td>
                                    <td>500,000</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>
<script>
export default {

}
</script>